export default __webpack_public_path__ + "static/media/03.c71d3318.jpg";